import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';

export const headerAnimations = [
  trigger('enterAnimation', [
    state('closed', style({ display: 'none' })),
    state('opened', style({ display: 'block' })),
    transition('* => opened', [
      style({
        transform: 'translateY(-100%)',
        zIndex: -1,
        opacity: 0,
        display: 'block',
      }),
      animate(
        '700ms cubic-bezier(0,0,.15,1)',
        style({
          transform: 'translateY(0)',
          opacity: 1,
        })
      ),
    ]),
    transition('opened => *', [
      style({
        transform: 'translateY(0)',
        opacity: 1,
        zIndex: -1,
        position: 'absolute',
      }),
      animate(
        '700ms cubic-bezier(0,0,.15,1)',
        style({
          transform: 'translateY(-100%)',
          opacity: 0,
          display: 'block',
        })
      ),
    ]),
  ]),
  trigger('blockInitialRenderAnimation', [transition(':enter', [])]),
];
